const isNoDuplicate = (array: any[]) => {
  if (array.length === 0) return false;
  return array.every((value, index, self) => self.indexOf(value) === index);
};

export { isNoDuplicate };
